// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"84144924","762":"376ce58b","787":"fc8966ee"}[chunkId] + ".chunk.js";
};